'use strict';

module.exports = require('./Table');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-table/lib/index.js
 ** module id = 1513
 ** module chunks = 0
 **/